import React from 'react';
import { Panel, Stack } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@rsuite/icons';
import { MdMeetingRoom } from 'react-icons/md';

interface FloorCardProps {
  floor: {
    id: number;
    name: string;
    totalSpaces: number;
    availableSpaces: number;
  };
}

const FloorCard: React.FC<FloorCardProps> = ({ floor }) => {
  const navigate = useNavigate();

  return (
    <Panel
      shaded
      bordered
      bodyFill
      style={{ cursor: 'pointer' }}
      onClick={() => navigate(`/office-workSpaces/${floor.id}`)}
    >
      <Stack direction="column" alignItems="center" spacing={16} style={{ padding: 20 }}>
        <Icon as={MdMeetingRoom} style={{ fontSize: 30 }} />
        <h5>{floor.name}</h5>
        <Stack spacing={8}>
          <div>Available: {floor.availableSpaces}</div>
          <div>Total: {floor.totalSpaces}</div>
        </Stack>
      </Stack>
    </Panel>
  );
};

export default FloorCard; 